import { ReactElement } from 'react'
import SnowLoadIcon from '../SnowLoadIcon'
import useSnowLoadAssignment from '../hooks/useSnowLoadAssignment'

interface Props {
  slab: ShapeObject
  color?: string
  opacity?: number
}

const SnowLoadIndicator = ({ slab, color, opacity }: Props): ReactElement => {
  const { hasSnowLoad, pointForIcon, rotation } = useSnowLoadAssignment({ slab })

  return (
    <SnowLoadIcon
      hasSnowLoad={hasSnowLoad}
      pointForIcon={pointForIcon}
      color={color}
      rotation={rotation}
      opacity={opacity}
    />
  )
}

export default SnowLoadIndicator
